import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuPartner = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.2002 13.251C12.3017 13.251 14.3211 14.0622 15.8135 15.5127C17.3066 16.9642 18.1504 18.9378 18.1504 21H16.6504C16.6504 19.3497 15.9758 17.7625 14.7686 16.5889C13.5605 15.4145 11.9175 14.751 10.2002 14.751C8.48281 14.751 6.83992 15.4145 5.63184 16.5889C4.42447 17.7626 3.75 19.3496 3.75 21H2.25C2.25 18.9378 3.09278 16.9642 4.58594 15.5127C6.07836 14.062 8.09853 13.251 10.2002 13.251ZM17.8418 13.3936C19.8017 14.8225 21.75 17.7722 21.75 20.999H20.25C20.25 18.3292 18.598 15.8022 16.958 14.6064L17.4004 14L17.8418 13.3936ZM10.5 3C12.7091 3 14.5 4.79086 14.5 7C14.5 9.20914 12.7091 11 10.5 11C8.29086 11 6.5 9.20914 6.5 7C6.5 4.79086 8.29086 3 10.5 3ZM15 3.25C17.0711 3.25 18.75 4.92893 18.75 7C18.75 9.07107 17.0711 10.75 15 10.75V9.25C16.2426 9.25 17.25 8.24264 17.25 7C17.25 5.75736 16.2426 4.75 15 4.75V3.25ZM10.5 4.5C9.11929 4.5 8 5.61929 8 7C8 8.38071 9.11929 9.5 10.5 9.5C11.8807 9.5 13 8.38071 13 7C13 5.61929 11.8807 4.5 10.5 4.5Z"
	})
});
export default SvgMenuPartner;
